import { FunctionComponent } from 'react'
import { Route } from 'react-router-dom'
import { withAuthenticator } from '@aws-amplify/ui-react'
import { default as MainLayout } from '../components/Layout'
import mockChats from 'data/mockChats.json'
import links from 'views/fullLinks'
import { Typography } from '@material-ui/core'
import DNav from 'components/DNav/DNav'
import Chat, { SChatMessage } from 'components/Chat/Chat'
import config from 'config'
import { useUser } from 'context/UserContext'

/*
const colors = {
    primary: "rgb(0, 128, 128)", // Teal
    light: "#ffffff",
    dark: "#000000"
}
*/

interface IAuthRouteProps {
    component: any
    layout?: any
    path: string
    [index: string]: any
}

const AuthRoute: FunctionComponent<IAuthRouteProps> = (
    props: IAuthRouteProps
) => {
    /*const AuthTheme = {
        button: { backgroundColor: colors.primary, border: colors.light },
    }*/
    const { layout: Layout = MainLayout, component: Component, ...rest } = props
    const handleChatRequest = () => {
        console.error('Error: Sending a chat not yet implemented.')
    }
    const { loading: loadingUser, user } = useUser()
    const [loading, chats] = [false, mockChats as SChatMessage[]] // Replace with storing of already pulled chat data
    return (
        <Route
            {...rest}
            render={(matchProps) => (
                <Layout
                    profile={user}
                    navContent={<DNav links={links} />}
                    asideContent={
                        <>
                            <Typography variant="h3" color="secondary">
                                Chat
                            </Typography>
                            <Chat
                                chats={chats}
                                untrustedChatSender={
                                    (!loadingUser &&
                                        user &&
                                        user?.userId) ||
                                    undefined
                                }
                                handleChatRequest={handleChatRequest}
                                noReframe={true}
                                formProps={{}}
                                loading={loading}
                            />
                        </>
                    }
                >
                    <Component {...matchProps} />
                </Layout>
            )}
        />
    )
}

export default withAuthenticator(AuthRoute, undefined) // Potentially add: , [], AuthTheme
//export default AuthRoute // Potentially add: , [], AuthTheme
